import { createFileRoute } from "@tanstack/react-router";
import { CustomerId } from "@yalana/contracts";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  customerId: CustomerId.optional(),
});

/**
 * @purpose Review existing roles and what each can do
 * @primary Roles table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/roles/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
